// Photos picked on the Photos page before saying which album they go in. They wait here, in memory only, for that
// album's page to open and add them the usual way (with its progress and its "make them easy to find" steps).
let waiting: { albumId: string; files: File[] } | null = null

export function handOffPhotos(albumId: string, files: File[]) {
  waiting = { albumId, files }
}

export function takeHandedOffPhotos(albumId: string): File[] {
  if (waiting?.albumId !== albumId) return []
  const { files } = waiting
  waiting = null
  return files
}

// Photos picked from Home's "+": they wait for that circle's Photos page to ask which album they go in, as its own
// "+" does.
let forPhotos: { familyId: string; files: File[] } | null = null

export function handOffToPhotos(familyId: string, files: File[]) {
  forPhotos = { familyId, files }
}

export function takePhotosFor(familyId: string): File[] {
  if (forPhotos?.familyId !== familyId) return []
  const { files } = forPhotos
  forPhotos = null
  return files
}
